<template>
    <ModalBase
        :name="name"
        title="Crear categoría"
        @close="$emit('close')"
    >
        <CategoriaForm
            :initial-data="null"
            submit-label="Guardar"
            :loading="loading"
            @submit="handleSave"
        />
    </ModalBase>
</template>

<script setup>
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import CategoriaForm from './CategoriaForm.vue'

    const props = defineProps({
        name: { type: String, required: true },
        loading: { type: Boolean, default: false }
    })
    const emit = defineEmits(['save', 'close'])

    function handleSave(formData) {
        emit('save', formData)
    }
</script>
